<template>
  <CommonCard>
    <div style="padding: 2%">
      <v-container>
        <v-row v-if="rol == 'VALIDADORCCALIANZAS' || rol == 'MANAGERCCALIANZAS'">
          <v-col cols="9"></v-col>
          <v-col cols="3">
            <v-select outlined v-model="opcionValidador" :items="opcionesValidador" item-text="label" item-value="id"
              label="Selecciona tipo de llamada validador" :clearable="false" :class="[
                'v-input--is-focused',
                'v-input--is-dirty',
                opcionValidador == 2
                  ? 'select-focus-fijo-green'
                  : 'select-focus-fijo-blue',
              ]" />
          </v-col>
        </v-row>
        <v-row class="mb-10" dense>
          <v-col cols="9">
            <span class="text-title-tables">Leads</span>
          </v-col>
          <v-col cols="2" style="align-items: end">
            <div class="d-flex align-items-center justify-space-between">
              <span class="text-elements-table">Elementos por página</span>
              <select name="choice" class="number" v-model="size">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
            </div>
          </v-col>
          <v-col cols="1" style="text-align: end">
            <span
              class="text-elements-table"
              @click="$router.push('/leads/buscar')"
              style="cursor: pointer"
            >
              Filtrar
              <v-icon class="mr-1">mdi-filter-variant</v-icon>
            </span>
          </v-col>

          <v-spacer />
        </v-row>
        <v-row dense align="center">
          <v-col cols="10">
            <v-text-field
              class="share-bar-clase"
              label="Buscar"
              outlined
              dense
              prepend-inner-icon="mdi-magnify"
              :light="true"
              v-model="filter"
              hint="Puedes buscar por: Nombre(s), Apellido(s), Correo y Campaña"
            >
            </v-text-field>
          </v-col>
          <v-col cols="2" style="text-align: end; margin-bottom: 25px">
            <span class="button-span-style" @click="$router.push('/crear-lead')"
              >Crear nuevo lead
              <v-icon color="#039ECC" class="mr-1"
                >mdi-plus-circle-outline</v-icon
              ></span
            >
          </v-col>
        </v-row>
      </v-container>
      <v-container class="pt-5">
        <v-row>
          <!-- <v-col
            cols="12"
            md="6"
            v-if="rol != 'AGENTCC' && rol != 'AGENTCCSPONSORS'"
          >
            <LeadsMarcacion :bus="bus" />
          </v-col> -->
          <v-col cols="12" md="12">
            <LeadsAgenda :size="size" :filter="filter" />
          </v-col>
        </v-row>
      </v-container>
      <!-- <CommonActionModal
        v-if="showCreacion"
        :dialog="showCreacion"
        @closeModal="showCreacion = false"
        @userChoice="userChoice"
        title="Crear nuevo lead"
        subtitle="¿Ya tiene una póliza emitida desde el portal de la aseguradora?"
        bottonText="Si"
        bottonTextCancel="No"
      /> -->
      <!-- <CrearLead
        v-if="showCreacion"
        :show="showCreacion"
        @close="showCreacion = false"
        @leadCreado="leadCreado"
      /> -->
    </div>
    <validador
      v-if="
        (rol == 'VALIDADORCCALIANZAS' || rol == 'MANAGERCCALIANZAS') && opcionValidador == 1
      "
    />
  </CommonCard>
</template>

<script>
import logoSegurify from "@/assets/logo_segurify.png";
import LeadsAgenda from "@/components/leads/LeadsAgenda";
import { loadScript } from "vue-plugin-load-script";
import LogoSegurify from "@/assets/logo_segurify.png";
import LogoBradescard from "@/assets/logo-inter-horizontal.png";
import Vue from "vue";
import CommonCard from "../../../components/commonComponents/CommonCard.vue";
import {
  getValidadoresLista,
  getLlamadaMasiva,
  updateLead,
  updateValidadorEstatus,
} from "@/services/leads/leads.service.js";
import validador from "@/components/validador/validador.vue";
import { updateValidador } from "@/services/validador/validador.service.js";

export default {
  components: {
    LeadsAgenda,
    CommonCard,
    validador,
  },

  data() {
    return {
      logoSegurify,
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      showCreacion: false,
      bus: new Vue(),
      intervalo: null,
      data: [],
      body : {
        "pathname" : window.location.pathname
      },
      isChecking: false,
      logo_1: LogoSegurify,
      width_log1: 80,
      height_log1: 80,
      logo_2: LogoBradescard,
      width_log2: 80,
      height_log2: 250,
      itemsForPage: 10,
      filter: "",
      size: 10,
      opcionValidador: 1,
      opcionesValidador: [
        {
          id: 1,
          label: "Disponible para transferencia",
        },
        {
          id: 2,
          label: "Marcación automática",
        },
      ],
    };
  },
  mounted() {
    loadScript(
      "https://aligev55.zw-callitonce.alestra.net.mx/agentdesktop/libs/servicepattern-sdk-v1.js"
    )
      .then(() => {
        window.bpspat.api.init("https://aligev55.zw-callitonce.alestra.net.mx");
      })
      .catch(() => {
        console.error(
          "Fallo al carga el sdk, Refresque la pagina para realizar la llamada"
        );
        location.reload();
      });
    setTimeout(() => {
      this.checkStatus();
      this.intervalo = window.setInterval(() => {
        this.checkStatus();
      }, 12000);
    }, 12000);
    window.addEventListener(
      "beforeunload",
      this.updateDisponibilidadValidadorOnTabClose
    );
  },
  beforeDestroy() {
    clearInterval(this.intervalo);
    window.removeEventListener(
      "beforeunload",
      this.updateDisponibilidadValidadorOnTabClose
    );
  },

  computed: {
    widthLogoSeg() {
      if (this.$vuetify.breakpoint.smAndDown) return "50";
      if (this.$vuetify.breakpoint.mdAndDown) return "50";
      return "80";
    },

    puedeCrear() {
      const rolesValidos = [
        "ADMIN",
        "ADMINCC",
        "MANAGERCC",
        "MANAGER",
        "ADMINAGENT",
        "DIRECTO",
        "OPERACIONES",
        "OPERADOR",
        "AGENTCC",
      ];
      return !!rolesValidos.find((e) => e == this.rol);
    },
  },
  watch: {
    opcionValidador(val) {
      if (val == 2) this.updateValidadorStatus(0);
    },
  },
  methods: {
    checkStatus() {
      if (
        (this.rol == "AGENTCCALIANZAS" || this.rol == "VALIDADORCCALIANZAS") &&
        !this.isChecking
      ) {
        window.bpspat.api.getState(this.statusChecked);
      }
    },
    async getLlamadaMasiva(body) {
      this.data = [];
      try {
        this.data = await getLlamadaMasiva(body);
        if (this.data.success === true) {
          clearInterval(this.intervalo);
          if (this.rol == "AGENTCCALIANZAS") {
            this.changeRoute(this.data.lead);
          } else if (this.rol == "VALIDADORCCALIANZAS" || this.rol == "MANAGERCCALIANZAS") {
            this.validadorRuta(this.data.lead)
          }
        }
      } catch (error) {
        console.error("Ha ocurrido un error al traer los leads")
        const msg = error.response?.data?.message || "Error inesperado";
        const type = error.response?.data?.type || "error";
        this.$toast[type](msg)
      }
    },
    statusChecked(state) {
      let status = state.data.status;
      let interactions = state?.data?.interactions ?? [];
      switch (status) {
        case "ready":
          if (this.rol == "AGENTCCALIANZAS") this.getLlamadaMasiva(this.body);
          else if (this.opcionValidador == 2) this.getValidadoresLista();
          break;
        case "busy": {
          let NotMessages = interactions.filter((e) => e.media_type !== "CHAT");
          let messages = interactions.filter((e) => e.media_type == "CHAT");
          if (
            NotMessages.length == 0 &&
            messages.length <= 8 &&
            this.rol == "AGENTCC"
          )
            this.getLlamadaMasiva(this.body);
          break;
        }
      }
    },
    changeRoute(item) {
      if (window.location.pathname == "/leads") {
        this.$router.push({
          path: "/segurify/leads-segurify/lead/" + item.uuid_lead_segurify,
          query: {
            llamadaMasiva: true,
            origenLeadUuid: item.uuid,
          },
        });
      } else {
        this.actualizarLead(item);
      }
    },
    async actualizarLead(item) {
      try {
        await updateLead(item.uuid);
      } catch {
        console.error("Error al actualizar lead");
      }
    },
    async updateValidadorEstatus(item) {
      return await updateValidadorEstatus(
        item.uuid,
        localStorage.getItem("id")
      );
    },
    async getValidadoresLista() {
      this.data = await getValidadoresLista();
      this.completarllamadaAuto();
    },
    validadorRuta(item) {
      this.$router.push({
        path: "/segurify/leads-segurify/lead/" + item.uuid_lead_segurify,
        query: {
          llamadaValidador: true,
          origenLeadUuid: item.uuid,
          llamadaMasivaValidador: true,
        },
      });
    },
    async updateValidadorStatus(isDisponible) {
      try {
        await updateValidador(isDisponible);
      } catch {
        console.error("Error a actualizar validador.");
      }
    },

    updateDisponibilidadValidadorOnTabClose() {
      // Método utilizado para los casos en que el usuario (validador) cierra la pestaña y se asegura de que el status de disponible se quede en 0
      const url = `${process.env.VUE_APP_API_URL}/v1/update/validador/disponible?isDisponible=0`;
      if (this.rol === "VALIDADORCCALIANZAS" || this.rol == "MANAGERCCALIANZAS") {
        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "agenteAccessToken"
            )}`,
          },
          keepalive: true,
        });
      }
    },

  },
  beforeRouteLeave(to, from, next) {
    if (this.rol === "VALIDADORCCALIANZAS" || this.rol == "MANAGERCCALIANZAS") {
      this.updateValidadorStatus(0)
        .then(() => next())
        .catch((e) => {
          console.error("Error al cambiar el status del validador:", e);
          next();
        });
    } else {
      next();
    }
  },
};
</script>

<style>
.select-focus-fijo-green .v-input__slot {
  border-width: 2px;
  border-color: #35a40f !important;
  /* tu color de foco */
  color: #35a40f !important;
}

.select-focus-fijo-green .v-label {
  color: #093e4c !important;
}

.select-focus-fijo-blue .v-input__slot {
  border-width: 2px;
  border-color: #039ecc !important;
  /* tu color de foco */
  color: #039ecc !important;
}

.select-focus-fijo-blue .v-label {
  color: #093e4c !important;
}
</style>